var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"text-center font-weight-bold",class:_vm.theme === 'dark' ? 'dark-footer' : 'light-footer',attrs:{"fluid":""}},[_c('p',[_vm._v("© Yoseph Martin Christian. All rights reserved.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }